import axios from "axios";
import { Base_URL } from "../url";

export const fetchSalaries = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/SalaryGetData/${id}`,
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching salary data!";
  }
};

/**
 * Get Salary Slip for selected employee + month + year
 */
/**
 * Get Salary Slip for selected employee + month + year
 */
export const getSalarySlip = async ({ orgId, resourceId, year, month }) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/GetSalarySlip`,
      {
        params: {
          orgId,
          resourceId,
          year,
          month,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error fetching salary slip";
  }
};

export const getAvailableSalaryPeriods = async ({ orgId, resourceId }) => {
  const res = await axios.get(
    `${Base_URL}/SalaryProcess/GetAvailableSalaryPeriods`,
    {
      params: { orgId, resourceId },
    },
  );
  return res.data;
};
